import { Component, Shark } from "shark-mvc";

import templateContent from "./print-button.html";

class PrintButtonComponent extends Component {
	constructor () {
		super("printButtonComponent");

		this.addTemplate("", templateContent);
	}
	
	printPageBtn_clickHandler () {
		window.print();
	}
}

const printButtonComponent = new PrintButtonComponent();

Shark.registerComponent(printButtonComponent);

export default printButtonComponent;
